// extracted by mini-css-extract-plugin
export default {"wrapper":"ShareClosetButton_wrapper__2he8Y","manualCopyInput":"ShareClosetButton_manualCopyInput__XbLXC","root":"ShareClosetButton_root__z7o0N"};